import {
  __,
  el,
} from '../common/variables';
import { cl, makeShortcodeString } from '../common/functions';

const save = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el('div', {},
    `${makeShortcodeString(attributes)}`
  );
}

export { save }
